export default {
    "navigation": {
        "allWatchfaces": "Toutes les apps",
        "faq": "FAQ",
        "helpCenter": "Aide et instructions",
        "newsletter": "Newsletter",
        "contact": "Contact",
        "weatherProvider": "Fournisseur Météo",
        "tides": "Marées",
        "colors": "Couleurs",
        "fonts": "Polices"
    },
    "homepage": {
        "title": "Apps TitanicTurtle",
        "subtitle": "Apps Garmin modernes avec des fonctionnalités avancées pour toutes vos activités",
        "features": {
            "tides": "🌊 Marées",
            "weather": "🌤️ Météo",
            "themes": "🎨 Thèmes de Couleur",
            "gps": "📍 GPS"
        },
        "availableWatchfaces": "Watchfaces Disponibles",
        "newBadge": "Nouveau",
        "loading": "Chargement des watchfaces...",
        "error": "Erreur de chargement",
        "retry": "Réessayer",
        "filter": {
            "label": "Product filter",
            "watchfaces": "Watchfaces",
            "apps": "Apps",
            "all": "All",
            "noProducts": "No products in this category"
        }
    },
    "faq": {
        "title": "Questions fréquemment posées",
        "subtitle": "Trouvez des réponses aux questions courantes sur nos cadrans",
        "tabs": {
            "search": "Recherche",
            "categories": "Catégories",
            "trending": "Tendances"
        },
        "search": {
            "placeholder": "Rechercher de l'aide...",
            "button": "Rechercher",
            "suggestions": "Recherches populaires",
            "tips": {
                "title": "Conseils de recherche",
                "keywords": "Utilisez des mots-clés spécifiques comme \"GPS\", \"météo\" ou \"paramètres\"",
                "language": "La recherche fonctionne dans votre langue sélectionnée",
                "categories": "Parcourez les catégories pour une aide organisée"
            }
        },
        "noResults": {
            "title": "Aucun résultat trouvé",
            "description": "Essayez différents mots-clés ou parcourez les catégories",
            "browseCategories": "Parcourir les catégories"
        },
        "suggestions": {
            "title": "Recherches populaires"
        },
        "trending": {
            "title": "Recherches tendances"
        },
        "categories": {
            "title": "Parcourir par catégorie",
            "items": "éléments",
            "allItems": "Tous les éléments FAQ",
            "allItemsDescription": "Parcourez toutes les questions fréquemment posées",
            "noItems": {
                "title": "Aucun élément dans cette catégorie",
                "description": "Essayez de sélectionner une catégorie différente"
            },
            "viewMore": "Voir tous les éléments"
        },
        "results": {
            "title": "Résultats de recherche",
            "found": "résultats trouvés pour",
            "total": "Total des résultats",
            "bestMatch": "Meilleur match",
            "categories": "Catégories",
            "sortBy": "Trier par",
            "sort": {
                "relevance": "Pertinence",
                "priority": "Priorité",
                "category": "Catégorie"
            },
            "lastUpdated": "Dernière mise à jour",
            "matchedIn": "Correspondance dans",
            "footer": "Vous n'avez pas trouvé ce que vous cherchiez?",
            "browseCategories": "Parcourir les catégories",
            "viewTrending": "Voir les tendances",
            "contactSupport": "Contacter le support"
        },
        "actions": {
            "copy": "Copier",
            "share": "Partager",
            "copyAnswer": "Copier la réponse",
            "copyAll": "Tout copier"
        },
        "loading": "Chargement des FAQ...",
        "error": "Erreur de chargement",
        "retry": "Réessayer"
    },
    "guides": {
        "backToHelp": "Retour",
        "purchase": {
            "title": "Achat et installation",
            "tabs": { "installation": "Installation", "versions": "VX / Elite", "troubleshooting": "Dépannage" },
            "installation": {
                "title": "Installer les watchfaces via l'app ConnectIQ",
                "intro": "Les watchfaces peuvent être installés sur la montre via l'app Garmin ConnectIQ (Android ou iOS).",
                "step1": "Connectez la montre au téléphone en Bluetooth et ouvrez l'app ConnectIQ.",
                "step2": "Allez sur la page du watchface à installer.",
                "step3": "Appuyez sur « Installer ». Le watchface est mis en file de téléchargement puis installé.",
                "step4": "Après l'installation, un message s'affiche et le watchface est disponible sur l'appareil.",
                "noteScreen": "Veillez à ce que l'écran du téléphone reste allumé et que l'app ConnectIQ reste ouverte pendant l'installation et les mises à jour.",
                "selectWatchfaceTitle": "Sélectionner le watchface sur la montre",
                "selectWatchfaceIntro": "Si le watchface est installé mais pas encore visible, sélectionnez-le dans le menu système de la montre.",
                "select1": "Maintenez le bouton menu de la montre (ou l'équivalent sur tactile) pour ouvrir le menu système.",
                "select2": "Allez à « Watch Faces » ou « Modèles d'affichage ».",
                "select3": "Liste des watchfaces installés. Utilisez les touches haut/bas ou le tactile pour naviguer.",
                "select4": "Validez avec le bouton en haut à droite. Le watchface est actif."
            },
            "versions": {
                "title": "VX vs Elite – quelle différence ?",
                "sameFeatures": "Les deux versions sont identiques en fonctionnalités. Seuls l'achat et l'activation diffèrent.",
                "eliteTitle": "Version Elite (Garmin Pay)",
                "elite1": "Installation séparée, achetée via Garmin Pay dans le ConnectIQ Store.",
                "elite2": "La version Elite est liée à votre compte Garmin. Nouvelle montre = réinstallation sans nouveau code.",
                "elite3": "Garmin Pay n'est pas disponible sur tous les modèles ni dans tous les pays.",
                "eliteNoKey": "Important : aucun code de déverrouillage n'est envoyé pour un achat Elite via Garmin Pay. La version Elite est déverrouillée directement après l'achat.",
                "vxTitle": "Version VX / Site web",
                "vx1": "Compatible avec plus d'appareils, souvent disponible quand Garmin Pay ne l'est pas.",
                "vx2": "Période d'essai gratuite de plusieurs jours.",
                "vx3": "Après l'essai, achetez un code de déverrouillage sur ce site pour débloquer la VX (ou les fonctions Pro).",
                "vx4": "Le code est valable uniquement pour l'appareil (WatchfaceID) pour lequel il a été acheté.",
                "vx5": "En cas d'échange de montre sous garantie Garmin, un nouveau code peut être généré. Contactez-nous via le formulaire."
            },
            "website": {
                "title": "Achat via le site (VX / versions normales)",
                "step1": "Installez d'abord le watchface (voir onglet Installation). La WatchfaceID n'apparaît qu'après installation dans les réglages.",
                "step2": "Ouvrez les réglages du watchface (app ConnectIQ ou Garmin Express) et copiez la WatchfaceID en haut.",
                "step3": "Sur ce site, choisissez le watchface et entrez votre WatchfaceID dans le formulaire d'achat.",
                "step4": "Finalisez le paiement. Vous recevrez le code par e-mail à saisir dans les réglages du watchface.",
                "noteNoAutoInstall": "Important : l'achat d'un code sur le site n'installe pas le watchface. Effectuez l'installation manuellement."
            },
            "troubleshooting": {
                "installationTitle": "Problèmes d'installation (file d'attente / mises à jour bloquées)",
                "installationIntro": "L'installation peut échouer, rester en attente ou l'app peut afficher des mises à jour sans fin.",
                "installationCause": "Cela vient généralement de l'app ConnectIQ ou des services Garmin, pas du watchface.",
                "installationFix1": "Redémarrez la montre et l'app ConnectIQ sur le téléphone.",
                "installationFix2": "Réessayez l'installation en gardant l'écran allumé et l'app ouverte.",
                "garminPayTitle": "Achat Garmin Pay bloqué « en cours »",
                "garminPayText": "Si un achat Garmin Pay reste longtemps « en cours », c'est géré par Garmin. Contactez le support Garmin officiel.",
                "noKeyTitle": "Je n'ai pas reçu de code après achat sur le site",
                "noKey1": "Vérifiez d'abord les spams. Les e-mails avec les clés y arrivent souvent.",
                "noKey2": "Souvent une erreur dans l'e-mail empêche la livraison. Contactez-nous avec l'e-mail utilisé et si possible la WatchfaceID.",
                "noKey3": " et indiquez l'adresse e-mail utilisée pour le paiement et si possible la WatchfaceID.",
                "noKeyElite": "En achetant une version Elite via Garmin Pay dans le ConnectIQ Store, aucun code n'est envoyé. La version Elite est déverrouillée directement."
            },
            "contactLink": "Formulaire de contact"
        },
        "timezones": {
            "title": "Fuseaux horaires et décalage UTC",
            "basicsTitle": "Qu'est-ce que les 2e et 3e fuseaux ?",
            "basicsText": "Dans beaucoup de watchfaces vous pouvez configurer deux fuseaux supplémentaires (souvent « deuxième » et « troisième » fuseau).",
            "offsetTitle": "Configurer les décalages UTC",
            "offsetIntro": "Dans les réglages, un champ permet d'entrer les décalages du 2e et 3e fuseau en minutes par rapport à UTC.",
            "offsetFormat": "La première valeur = 2e fuseau, la deuxième = 3e fuseau, en minutes, séparées par un espace. Pas de + pour les positifs.",
            "exampleLabel": "Exemple :",
            "exampleExplanation": "Ici le 2e fuseau a un décalage de -4,5 h (−270 min) et le 3e de +2 h (+120 min) par rapport à UTC.",
            "changeExample": "Pour un 2e fuseau à +6 h, la première valeur doit être 360 (6×60). Exemple : 360 120",
            "advancedTitle": "Options avancées (suffixe A/B/C)",
            "advancedOptionalHint": "Cette section est facultative. Utile uniquement si votre watchface prend en charge les suffixes A/B/C.",
            "advancedIntro": "Le fait que votre watchface prenne en charge ces suffixes est indiqué dans le texte de description au-dessus du champ de décalage dans les réglages du watchface. Si c'est le cas, vous verrez une description du type :",
            "advancedExample": "Décalage UTC 2e et 3e fuseau en minutes (séparer par un espace) (lettres : A = 12h, B = 24h, C = format militaire, vide = standard)",
            "advancedNote": "Les lettres A/B/C optionnelles règlent le format d'affichage sur certains watchfaces. À utiliser seulement si le watchface le mentionne.",
            "exampleSectionTitle": "Pas à pas : Exemple pour différentes villes et formats",
            "exampleIntro": "L'exemple suivant montre comment régler une 2e zone (ex. New York) et une 3e (ex. Tokyo), et éventuellement choisir l'affichage 12h ou 24h pour chacune.",
            "exampleStep1Title": "Étape 1 : Décalage UTC pour la 2e zone",
            "exampleStep1Text": "Choisissez la ville ou la région pour la 2e zone. Convertissez son décalage par rapport à l'UTC en minutes. Ex. : New York (EST, UTC−5) → −300 minutes. Saisissez cette valeur en premier dans le champ.",
            "exampleStep2Title": "Étape 2 : Décalage UTC pour la 3e zone",
            "exampleStep2Text": "Même chose pour la 3e zone. Ex. : Tokyo (JST, UTC+9) → 540 minutes. C'est la deuxième valeur, séparée par un espace de la première.",
            "exampleOnlyOffsets": "Si votre watchface n'utilise pas les suffixes A/B/C, c'est tout. Saisissez :",
            "exampleStep3Title": "Étape 3 : Suffixe de format optionnel (A/B/C)",
            "exampleStep3Optional": "Cette étape est optionnelle : vous pouvez omettre les suffixes même si le watchface les supporte ; le format par défaut sera utilisé. Pour forcer 12h, 24h ou format militaire par zone, ajoutez la lettre directement après le décalage — sans espace entre décalage et suffixe.",
            "exampleStep3Text": "Exemple : format 12h pour New York (A) et 24h pour Tokyo (B) :",
            "exampleStep3Note": "Aucun suffixe = affichage par défaut du watchface (souvent 24h). Le fait que les suffixes soient supportés est indiqué dans la description au-dessus du champ de décalage dans les réglages du watchface.",
            "exampleFormatTitle": "Affichage de l'heure avec A, B, C",
            "exampleFormatIntro": "Pour un même instant, l'affichage varie selon le format (ex. : 2e zone New York -300, 3e zone Tokyo 540). Aperçu en direct :",
            "zone2": "2e zone",
            "zone3": "3e zone",
            "exampleTableTitle": "Référence : Décalages UTC pour quelques villes (en minutes)",
            "exampleTableIntro": "Heure normale ; l'heure d'été peut différer. Multipliez les heures par 60."
        },
        "switchViews": {
            "title": "Switchviews et gestes",
            "wordLabel": "vue de remplacement",
            "basicsTitle": "Qu'est-ce que les Switchviews ?",
            "basicsText": "Beaucoup de watchfaces affichent d'autres infos dans la même zone. Ces vues sont souvent nommées « Switchview » ({{wordLabel}}), « Switchview 2 », « Top View 1/2 », « Bottom View 1/2 » dans les réglages.",
            "proNote": "Souvent ce sont des fonctions Pro disponibles en essai puis nécessitant une clé.",
            "gestureTitle": "Changer de vue par geste du poignet",
            "gestureIntro": "Sans tactile compatible, les vues alternatives se changent par un second geste du poignet.",
            "gestureStep1": "Levez le poignet comme d'habitude pour réveiller l'écran (secondes ou écran allumé).",
            "gestureStep2": "En quelques secondes (environ 7 s), refaites le geste – pas trop brusque, mais net.",
            "gestureStep3": "Si le watchface gère les Switchviews, les zones configurées passent à la page suivante.",
            "gestureHint": "Si rien ne change, vérifiez les réglages : certaines vues doivent être assignées (ex. « Top View 2 » / « Bottom View 2 »).",
            "touchTitle": "Switchviews sur appareils tactiles",
            "touchIntro": "Sur les montres avec tactile (ex. Fenix 7 et plus), les vues peuvent aussi se changer en appuyant sur des zones tactiles.",
            "touchConfig": "Dans les réglages, souvent en bas de liste, vous pouvez configurer ces zones (chiffres heure/minute ou zones dédiées).",
            "touchHold": "Un appui long sur la zone configurée change la vue assignée.",
            "touchMultiple": "Certains watchfaces ont plusieurs zones (ex. une pour la vue du haut, une pour le bas).",
            "touchInfo": "Les zones spéciales sont en général décrites dans la fiche du watchface sur ce site ou dans le ConnectIQ Store."
        },
        "findWfId": {
            "title": "Comment trouver votre WatchfaceID",
            "whatIs": "Qu'est-ce que la WatchfaceID ?",
            "whatIsExplanation": "Chaque watchface a une WatchfaceID par appareil (nombre de 5 à 6 chiffres). Elle est nécessaire pour acheter un code d'activation ou pour le support.",
            "connectIqTitle": "Via l'app ConnectIQ (recommandé)",
            "ciq1": "Vérifiez que la montre est connectée au téléphone en Bluetooth.",
            "ciq2": "Ouvrez l'app ConnectIQ.",
            "ciq3": "Allez sur la page du watchface (description et images). Sinon, utilisez la recherche ou « Mes watchfaces » dans « Appareil ».",
            "ciq4": "Appuyez sur « Réglages » sur la page du watchface.",
            "ciq5": "La WatchfaceID est dans le champ du haut. Copiez ce numéro – c'est l'ID pour le paiement.",
            "keyEntryTitle": "Saisie du code d'activation",
            "keyEntryExplanation": "Sous le champ WatchfaceID se trouve le champ pour le code envoyé après paiement. Certains watchfaces y affichent les jours d'essai restants – effacez avant de saisir le code.",
            "garminExpressTitle": "Via Garmin Express (ordinateur)",
            "ge1": "Installez Garmin Express et connectez la montre.",
            "ge2": "Ouvrez la liste des watchfaces installés.",
            "ge3": "Cliquez sur les trois points à côté du watchface pour ouvrir les réglages.",
            "ge4": "Même principe qu'avec l'app ConnectIQ.",
            "geNote": "L'app ConnectIQ est recommandée ; certaines versions de Garmin Express peuvent poser problème.",
            "zeroId": "WatchfaceID affiche 0 ?",
            "zeroIdExplanation": "Parfois la WatchfaceID s'affiche à 0. Enregistrez une fois les réglages ou redémarrez la montre. Si ça reste à 0, le paiement fonctionne souvent quand même."
        },
        "location": {
            "title": "GPS et position",
            "whatIsGpsFix": "Qu'est-ce qu'un fix GPS ?",
            "gpsFixExplanation": "Un fix GPS indique au watchface votre position pour calculer lever/coucher du soleil, phases de lune, météo et marées.",
            "howTo": "Effectuer un fix GPS",
            "step1": "Sur la montre, allez à l'écran de démarrage d'une activité (ex. « Course »).",
            "step2": "Attendez que la montre ait le signal GPS (barre/icône verte).",
            "step3": "Revenez au watchface – les données se mettent à jour en quelques minutes.",
            "alternative": "Alternative : GPS du téléphone",
            "alternativeExplanation": "Vous pouvez activer le GPS du téléphone. La montre doit être connectée en Bluetooth. Plus lent mais tout aussi valable.",
            "requirements": "Prérequis",
            "req1": "Montre connectée au téléphone en Bluetooth",
            "req2": "App Garmin Connect (pas Connect IQ) au moins en arrière-plan",
            "req3": "GPS activé sur le téléphone si vous utilisez la position du téléphone"
        },
        "settings": {
            "tabs": { "options": "Options de champs de données", "change": "Modifier les réglages", "troubleshoot": "Dépannage" },
            "title": "Réglages du watchface",
            "optionsIntro": "Liste générale de toutes les options de champs de données. Cliquez pour voir la description. Toutes les options ne sont pas disponibles sur tous les watchfaces.",
            "change": {
                "title": "Comment modifier les réglages du watchface",
                "intro": "Les réglages du watchface se modifient via l'app ConnectIQ sur le téléphone.",
                "step1": "Connectez la montre au téléphone en Bluetooth et ouvrez l'app ConnectIQ (pas l'app Connect).",
                "step2": "Allez sur la page du watchface. S'il n'est pas encore installé, installez-le d'abord.",
                "step3": "Sur la page du watchface, appuyez sur le bouton « Réglages » pour ouvrir la liste des réglages.",
                "step4": "Tous les champs de données, couleurs et options avancées sont modifiables ici.",
                "step5": "Appuyez sur le bouton d'enregistrement en haut à droite pour transférer les réglages sur la montre.",
                "installLink": "Guide d'installation"
            },
            "troubleshoot": {
                "title": "Dépannage",
                "cantSave": { "q": "Les réglages ne peuvent pas être enregistrés", "a1": "Parfois les serveurs Garmin ont des difficultés avec certains caractères.", "a2": "Videz le champ du thème de couleurs (s'il existe) puis réenregistrez." },
                "wontOpen": { "q": "Les réglages ne s'ouvrent pas", "a1": "Fermez complètement l'app ConnectIQ et redémarrez la montre si besoin.", "a2": "Si vous ne voyez qu'un bouton « Installation », le watchface n'est pas encore installé." },
                "missingOptions": { "q": "Je ne trouve pas une option de réglage", "a": "Toutes les options ne sont pas disponibles sur tous les appareils." },
                "naValue": { "q": "Un champ affiche seulement « n/a »", "a": "Votre appareil ne prend pas en charge cette option (modèle plus ancien ou matériel manquant)." }
            }
        },
        "dateFormat": {
            "title": "Format de date personnalisé (Date 1 / 2 / 3)",
            "basicsTitle": "À quoi servent les champs de format de date ?",
            "basicsIntro": "Dans les réglages du watchface, deux champs (ou trois) permettent de configurer l'affichage de Date 1, Date 2 et éventuellement Date 3. Les lettres que vous saisissez définissent le format affiché.",
            "notAll": "Ce n'est pas disponible sur tous les watchfaces.",
            "where": "Les champs se trouvent en général plus bas dans les réglages, sous les options de champs de données.",
            "codesTitle": "Codes de format",
            "codesIntro": "Vous pouvez utiliser les lettres suivantes dans le champ. Le résultat reflète la date actuelle.",
            "codeD": "jour du mois (avec zéro initial)",
            "codeDText": "jour en texte (ex. lundi)",
            "codeM": "mois en chiffres (avec zéro initial)",
            "codeMText": "mois en texte",
            "codeY": "année sur deux chiffres",
            "codeY4": "année sur quatre chiffres",
            "codeJ": "date julienne (militaire)",
            "codeW": "numéro de semaine",
            "codeO": "mois sans zéro initial",
            "codeN": "jour sans zéro initial",
            "codeP": "jour de l'année",
            "exampleHint": "Ex. « D, d.M.Y » peut afficher « lun., 27.02.2026 »."
        }
    },
    "themeInfo": {
        "howDoThemesWork": {
            "title": "Comment fonctionnent les thèmes ?",
            "description": "En haut des réglages du watchface, le « themestring » représente vos réglages de couleurs (icônes, graphique, heure…). En modifiant puis en enregistrant, le themestring se met à jour. Vous pouvez le copier pour sauvegarder ou partager vos couleurs (ex. avis / forum) et appliquer ceux des autres."
        },
        "dynamicThemeSwitching": {
            "title": "Changement de thème dynamique",
            "sunset": {
                "title": "Changer après le coucher / avant le lever du soleil",
                "description": "Mettez un ! devant le themestring cible pour qu'il soit utilisé après le coucher du soleil (ex. !UEUE[UEUEEEEEEU^). Pour supprimer, mettez uniquement ! dans le champ."
            },
            "lowPower": {
                "title": "Changer en mode économie",
                "description": "Même principe qu'au-dessus mais avec # devant le themestring (ex. #UEUE[UEUEEEEEEU^). Le mode économie s'active après ~10 s. Les deux options peuvent être combinées. Pensez à sauvegarder le themestring ailleurs car il n'est plus visible dans les réglages."
            }
        }
    },
    "helpCenter": {
        "title": "Aide et instructions",
        "subtitle": "Réponses, guides et instructions pour votre watchface",
        "guidesTitle": "Guides et instructions",
        "faqTitle": "Questions fréquentes",
        "allCategories": "Tout",
        "guides": "Guides",
        "faqResults": "FAQ",
        "noResults": "Aucun résultat trouvé",
        "noResultsHint": "Essayez d'autres mots-clés ou parcourez les catégories et guides ci-dessous."
    },
    "watchfacesOverview": {
        "title": "Toutes les apps",
        "loading": "Chargement des watchfaces...",
        "error": "Erreur de chargement des watchfaces",
        "retry": "Réessayer",
        "noWatchfaces": "Aucun watchface disponible"
    },
    "detailTabs": {
        "payment": "Paiement",
        "themes": "Thèmes",
        "info": "Info",
        "instructions": "Instructions",
        "instructionsIntro": "Tous les guides et instructions en un coup d'œil :",
        "noThemes": "Aucun thème de couleur disponible pour ce watchface."
    },
    "watchfaceDetail": {
        "loading": "Chargement du watchface...",
        "error": {
            "notFound": "Watchface introuvable",
            "loading": "Erreur de chargement du watchface"
        },
        "backToOverview": "Retour à l'aperçu",
        "goToStore": "Aller au IQ Store",
        "goToTrial": "Version d'essai",
        "devices": "appareils",
        "info": {
            "title": "Fonctionnalités",
            "tides": "🌊 Informations sur les marées avec mises à jour automatiques",
            "weather": "🌤️ Données météo d'OpenWeatherMap et Yr",
            "colors": "🎨 Thèmes de couleur et personnalisations",
            "location": "📍 Détermination de la position par GPS",
            "faq": "❓ FAQ et support",
            "weatherFallback": "Sans abonnement One Call 3.0, une clé API OpenWeatherMap utilise le fournisseur \"Yr\" en repli."
        }
    },
    "colorThemes": {
        "clickToCopy": "Cliquer pour copier",
        "clickToPreview": "Cliquer pour prévisualiser",
        "closePreview": "Fermer la prévisualisation",
        "copied": "Copié !",
        "useInSettings": "Utilisez-le dans les paramètres de votre watchface",
        "guideLink": "Plus d'infos sur les thèmes et chaînes de thème",
        "deviceNote": "Les thèmes de couleur ne sont pas disponibles sur tous les appareils.",
        "noFieldNote": "Si les paramètres de votre watchface ne contiennent pas de champ séparé pour les thèmes de couleur, ceux-ci ne sont pas supportés pour votre modèle de montre sur ce watchface."
    },
    "payment": {
        "option1": {
            "title": "Option 1 : Garmin Pay",
            "description": "Achetez le watchface payant via Garmin Pay sur le ConnectIQ Store (si votre montre est prise en charge).",
            "link": "Lien vers le ConnectIQ Store"
        },
        "option2": {
            "title": "Option 2 : Paiement direct via WatchfaceID",
            "description": "Si votre montre n'est pas prise en charge par la version Pro, vous pouvez acheter une clé version Trial/VX en saisissant votre WatchfaceID.",
            "vxNote": "Ceci est une clé pour la version VX du watchface, pas la version Garmin Pay !",
            "vxLink": "Lien vers la version VX"
        },
        "tax": "TVA",
        "wfid": {
            "description": "Entrez votre WatchfaceID (dans les paramètres du watchface)",
            "placeholder": "Entrez la WatchfaceID (5-6 chiffres)",
            "guideLink": "Comment trouver votre WatchfaceID",
            "guideLinkShort": "Afficher les instructions"
        },
        "wfidError": {
            "letters": "La WatchfaceID ne doit contenir que des chiffres",
            "tooLong": "La WatchfaceID doit compter 5 à 6 chiffres",
            "invalid": "Veuillez entrer une WatchfaceID valide (5-6 chiffres)",
            "lengthHint": "Une WatchfaceID comporte généralement 5 à 6 chiffres. Vérifiez."
        },
        "errors": {
            "empty": "Veuillez entrer votre WatchfaceID",
            "invalid": "Veuillez entrer une WatchfaceID valide",
            "config": "Erreur de configuration du paiement",
            "checkout": "Impossible d'ouvrir le paiement. Réessayez."
        },
        "buy": "Acheter",
        "selectMethod": "Choisissez votre version",
        "versionSelectHint": "Ce sont deux versions distinctes — veuillez sélectionner la bonne :",
        "vxWarning": "Les versions VX et Elite sont chacune des versions téléchargeables séparément du cadran. Un code d'activation pour la version VX ne déverrouille PAS la version Elite.",
        "beta": {
            "title": "Actuellement en bêta",
            "description": "Pendant cette phase bêta, vous pouvez utiliser ce watchface entièrement gratuitement. Aucun prélèvement automatique n’aura lieu après la période de test. De nouvelles fonctions et améliorations sont testées pendant cette période. Merci pour vos retours !",
            "descriptionApp": "Pendant cette phase bêta, vous pouvez utiliser cette app entièrement gratuitement. Aucun prélèvement automatique n’aura lieu après la période de test. De nouvelles fonctions et améliorations sont testées pendant cette période. Merci pour vos retours !"
        },
        "elite": {
            "badge": "Garmin Pay",
            "title": "Version Elite",
            "description": "Ce watchface est disponible uniquement via Garmin Pay sur le ConnectIQ Store.",
            "comboDescription": "Achetez via Garmin Pay sur le ConnectIQ Store. Version séparée et autonome.",
            "compatibility": "Garmin Pay n'est pas pris en charge sur toutes les montres. Vérifiez la compatibilité sur la page Store. Sinon, téléchargez la version VX (identique).",
            "storeLink": "Ouvrir dans le ConnectIQ Store",
            "moreGuide": "Besoin de détails sur la différence Elite / VX ?",
            "moreGuideLink": "Lire le guide achat et installation",
            "eliteNoKey": "Lors de l'achat d'une version Elite via Garmin Pay, aucun code de déverrouillage n'est envoyé. La version Elite est déverrouillée directement après l'achat et ne nécessite pas de code.",
            "accountBound": "L'achat via Garmin Pay est lié à votre compte Garmin et disponible automatiquement pour vos futurs appareils (si compatible).",
            "eliteNoKeyAndGuide": "Lors de l'achat via Garmin Pay, aucun code n'est envoyé — la version Elite est déverrouillée directement après l'achat. Plus de détails dans le guide d'achat et d'installation."
        },
        "vx": {
            "badge": "Tous appareils",
            "title": "Version VX",
            "description": "Compatible avec tous les appareils pris en charge. Téléchargez la version d'essai depuis le ConnectIQ Store, puis activez-la ici avec un code acheté.",
            "trialNote": "La version VX inclut une période d'essai. Ensuite, achetez un code d'activation ci-dessous pour la débloquer.",
            "deviceBound": "Un code d'activation est lié à votre appareil et déverrouille la version VX de manière permanente.",
            "moreGuide": "Plus d'infos sur la version VX, les clés ou l'installation ?",
            "moreGuideLink": "Lire le guide achat et installation",
            "downloadLink": "Télécharger la version VX",
            "details": {
                "line1": "Après paiement, la clé d'activation sera envoyée à l'adresse e-mail que vous indiquerez à l'étape suivante.",
                "line2": "Veuillez vérifier que l'adresse e-mail est correcte.",
                "line3": "Vérifiez votre dossier spam après le paiement – les e-mails de clés y arrivent souvent.",
                "line4": "Tous les paiements sont gérés par Paddle – aucun compte requis.",
                "line5": "Pour le support, utilisez le formulaire de contact ou l'outil ConnectIQ Store.",
                "line6": "Les autres demandes ne peuvent pas être traitées."
            }
        },
        "standalone": {
            "title": "Acheter un code d'activation",
            "description": "Achetez un code d'activation en entrant votre WatchfaceID ci-dessous. Le code vous sera envoyé immédiatement."
        },
        "checkoutOpening": "Ouverture du paiement...",
        "info": {
            "key": "Après l'achat, vous recevrez une clé à entrer dans les paramètres du watchface.",
            "activation": "La clé est activée immédiatement après paiement.",
            "support": "Pour toute question, contactez le support.",
            "moreGuide": "Plus d'infos sur l'achat et l'installation"
        },
        "methods": {
            "applePay": "Apple Pay",
            "googlePay": "Google Pay",
            "alipay": "Alipay",
            "paypal": "PayPal",
            "creditCard": "Carte bancaire"
        }
    },
    "footer": {
        "tagline": "Apps Garmin modernes avec des fonctionnalités avancées pour toutes les activités.",
        "description": "Apps Garmin modernes avec des fonctionnalités avancées pour toutes les activités."
    },
    "newsletter": {
        "title": "Newsletter",
        "description": "Abonnez-vous à la newsletter pour des mises à jour sur les nouveaux cadrans, fonctionnalités et offres.",
        "frequencyHint": "Environ un e-mail tous les deux mois. Désinscription possible à tout moment.",
        "emailPlaceholder": "Votre adresse e-mail",
        "subscribe": "S'abonner",
        "unsubscribe": "Se désabonner",
        "subscribeSuccess": "Inscription réussie ! Consultez vos e-mails.",
        "subscribeError": "Une erreur s'est produite. Veuillez réessayer plus tard.",
        "unsubscribeSuccess": "Désinscription effectuée.",
        "unsubscribeError": "Une erreur s'est produite. Veuillez réessayer plus tard."
    },
    "contact": {
        "title": "Contact",
        "description": "Une question ou besoin d’aide ? Envoie-moi un message.",
        "emailLabel": "E-mail",
        "emailPlaceholder": "ton@email.fr",
        "deviceLabel": "Appareil (optionnel)",
        "devicePlaceholder": "ex. Fenix 7",
        "watchfaceLabel": "Watchface (optionnel)",
        "watchfacePlaceholder": "ex. Horizon",
        "messageLabel": "Message",
        "messagePlaceholder": "Ton message...",
        "send": "Envoyer le message",
        "sendAnother": "Envoyer un autre message",
        "successTitle": "Message envoyé !",
        "successMessage": "Je te répondrai dès que possible.",
        "error": "Une erreur s’est produite. Réessaie ou écris directement à dev@orcatec.net.",
        "rateLimit": "Maximum 2 messages par 5 minutes. Réessaie plus tard.",
        "consentNotice": "En envoyant ce formulaire, tu acceptes le traitement de tes données conformément à ma",
        "guidesIntro": "Si tu as des questions sur des fonctions spécifiques, ces guides contiennent peut-être déjà la réponse :",
        "faqIntro": "Pour de nombreux sujets, il existe aussi une FAQ détaillée :",
        "faqLinkLabel": "Ouvrir Aide & Instructions",
        "responseTimeNotice": "Merci de comprendre qu’en période de forte charge, une réponse peut parfois prendre plusieurs jours."
    },
    "fonts": {
        "title": "Polices",
        "timefonts": "Polices d'heure",
        "datafonts": "Polices de données"
    },
    "common": {
        "loading": "Chargement...",
        "error": "Erreur",
        "retry": "Réessayer",
        "back": "Retour",
        "close": "Fermer",
        "save": "Enregistrer",
        "cancel": "Annuler",
        "confirm": "Confirmer",
        "notFound": "404 – Page introuvable"
    },
    "bierwander": {
        "title": "Bierwandern",
        "intro": "L'application Bierwandern vous permet de suivre votre randonnée et les recharges que vous dégustez en chemin. En plus, une estimation du taux d'alcoolémie avec graphique (estimation approximative) – mais ne la prenez pas au sérieux !",
        "settingsHint": "Sur l'écran de démarrage, appuyez sur le bouton menu de votre montre pour accéder aux paramètres (sur les montres à 2 boutons, appuyez longuement sur l'écran tactile).",
        "disclaimer": "Le calcul de l'alcoolémie est une métrique purement ludique – un algorithme qui estime l'alcoolémie selon les boissons consommées et le poids corporel ! Ne prenez aucune décision sur la base de cette valeur – elle n'est pas fiable et ne constitue pas une mesure réelle de l'alcoolémie !",
        "closing": "Sinon, je vous souhaite de bonnes randonnées et un bon moment !",
        "support": "En cas de problème ou de suggestion d'amélioration, utilisez le bouton « App Support » – merci."
    },
    "bodysurf": {
        "intro": {
            "title": "Qu'est-ce que BodySurf ?",
            "text": "BodySurf est une application Garmin Connect IQ pour le bodysurf. Elle utilise le GPS pour détecter quand vous surfez une vague, mesure la distance et la durée de chaque ride et attribue un titre amusant selon la distance parcourue. Les sessions sont enregistrées comme activités avec des tours individuels dans Garmin Connect."
        },
        "gps": {
            "title": "Avant de commencer – GPS",
            "text1": "Attendez un fix GPS avant de démarrer une session. Sur l'écran de démarrage vous verrez « Recherche GPS » jusqu'à l'obtention du signal, puis « DÉMARREZ pour commencer ».",
            "text2": "Pour une meilleure précision, l'app utilise le GPS multi-GNSS / double bande si votre montre le supporte. Restez immobile un moment près de l'eau si le fix prend du temps."
        },
        "start": {
            "title": "Écran de démarrage",
            "startBtn": "Démarrez une nouvelle session une fois le GPS prêt (DÉMARREZ = commencer la session).",
            "menuBtn": "Ouvrez les réglages : Comment utiliser et Unités (MENU = paramètres / info).",
            "backBtn": "RETOUR = quitter l'application"
        },
        "during": {
            "title": "Pendant l'activité",
            "detect": "Les balades sont détectées par GPS vitesse automatiquement. Utilisez RETOUR pour commencer/arrêter une balade manuellement. Les mouvements courts de moins de 2 mètres sont ignorés.",
            "startBtn": "DÉMARREZ = arrêter / sauvegarder / reprendre",
            "backBtn": "RETOUR = balade manuelle on/off",
            "live": "Pendant la ride vous voyez la distance actuelle, un titre en direct et « EN BALADANT ! ». Après une ride, le titre et les stats restent visibles jusqu'à la prochaine."
        },
        "stop": {
            "title": "Menu d'arrêt",
            "resume": "Reprendre",
            "save": "Sauvegarder",
            "discard": "Jeter"
        },
        "after": {
            "title": "Après la session",
            "summary": "Le résumé affiche le temps de session, le nombre de Balades, la distance totale et votre meilleure ride (Meilleur) avec titre et stats.",
            "rides": "Glissez pour voir les détails de la balade. Sur montres à boutons : << DOWN rides.",
            "finished": "Ensuite : Nouvelle session avec START ou Quitter l'application avec RETOUR."
        },
        "titles": {
            "title": "Titres de ride",
            "intro": "Chaque balade reçoit un titre amusant basé sur la distance. Plus la balade est longue, meilleur est le titre !",
            "colDistance": "Distance",
            "colTitle": "Titre",
            "th0": "Épave",
            "th1": "Concombre",
            "th2": "Flet",
            "th3": "Anti-mouette",
            "th4": "Shérif côtier",
            "th5": "Inspecteur",
            "th6": "Surfeur",
            "th7": "Conseiller",
            "th8": "Brise-vague",
            "th9": "Aquaman",
            "th10": "Planche de surf humaine",
            "th11": "Légende du littoral",
            "th12": "Poséidon"
        },
        "connect": {
            "title": "Garmin Connect",
            "text": "Les sessions enregistrées apparaissent dans Garmin Connect avec des champs personnalisés : titre de ride, distance du tour (mètres), temps du tour (secondes) et plus longue ride/temps au niveau session. Chaque ride détectée est enregistrée comme un tour."
        },
        "instinct": {
            "title": "Instinct 2 / 3 (MIP)",
            "layout": "Sur Instinct, le sous-écran affiche l'heure, le GPS et la distance. Utilisez le bouton BAS au lieu du swipe (<< DOWN rides).",
            "menu": "« Menu » est affiché à gauche sur l'écran de démarrage. Appuyez sur DÉMARREZ quand GPS OK apparaît dans le sous-écran."
        },
        "settings": {
            "title": "Réglages",
            "units": "Unités : basculez entre métrique et impérial pour distance et vitesse sur la montre.",
            "info": "Info : aide intégrée (Comment utiliser) pour les boutons pendant l'activité, après la session et sur l'écran de démarrage."
        },
        "supportBefore": "Pour tout problème ou suggestion, utilisez le",
        "supportLink": "formulaire de contact",
        "supportAfter": " – merci !"
    }
};
